import { useSignout } from '../../../hooks/useSignout';

import { ReactComponent as ProfileLogout } from '../../../assets/profile/icons/profile-logout.svg';

import styles from './MenuAccountDropdown.module.scss';
import MenuAccountDropdownBalanceSection from './menuAccountDropdownBalanceSection/MenuAccountDropdownBalanceSection';
import MenuAccountDropdownProfileSection from './menuAccountDropdownProfileSection/MenuAccountDropdownProfileSection';

interface MenuAccountDropdownProps {
  show: boolean;
  variant?: 'default' | 'referral';
}

const MenuAccountDropdown = ({ show, variant = 'default' }: MenuAccountDropdownProps) => {
  const signOut = useSignout();

  const dropdownClassNames = [
    styles['account-dropdown'],
    variant === 'referral' ? styles['account-dropdown--referral'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  const baseButtonClassNames = [
    styles['dropdown-item__button'],
    'button--styleless',
    variant === 'referral' ? styles['dropdown-item__button--referral'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  return show ? (
    <div className={dropdownClassNames}>
      <MenuAccountDropdownBalanceSection variant={variant} />
      <MenuAccountDropdownProfileSection variant={variant} />
      <ul className={styles['dropdown-list']}>
        <li className={styles['dropdown-item']}>
          <button className={baseButtonClassNames} onClick={() => signOut()}>
            <ProfileLogout />
            <span>Log out</span>
          </button>
        </li>
      </ul>
    </div>
  ) : (
    <></>
  );
};

export default MenuAccountDropdown;